import { useAuthLoading, useUserData } from "@context/OAuth/AuthContext";
import { getAccessToken } from "@context/OAuth/authService";
import useNetworkStatus from "@hooks/useNetworkStatus";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NetworkGuard = ({ children }) => {
  const isOnline = useNetworkStatus();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthLoading, setIsAuthLoading } = useAuthLoading();
  const { subscription } = useUserData();

  // useEffect(() => {
  //   if(getAccessToken()){
  //     // Scenario 1: Physical Internet Loss
  //     if (!isOnline && location.pathname !== "/no-connection") {
  //       // setIsAuthLoading(false);
  
  //       localStorage.setItem("lastLocation", location.pathname + location.search);
  //       // We don't pass a state here, which signals to the next page it's a network issue
  //       navigate("/no-connection", { replace: true });
  //     }
  //     // if (
  //     //   !isAuthLoading &&
  //     //   !subscription &&
  //     //   location.pathname !== "/no-connection"
  //     // ) {
  //     //   localStorage.setItem("lastLocation", location.pathname + location.search);
  //     //   // Pass "server_error" state to disable auto-comeback loop
  //     //   navigate("/no-connection", {
  //     //     state: { reason: "server_error" },
  //     //     replace: true,
  //     //   });
  //     // }
  //   }
  // }, [isOnline, navigate, location.pathname, location.search,getAccessToken()]);

  useEffect(() => {
    // Scenario 2: Server/API 500 Error
    const handle500Error = () => {
      if (location.pathname !== "/server-error") {
        setIsAuthLoading(false);
        localStorage.setItem(
          "lastLocation",
          location.pathname + location.search
        );
        // Pass "server_error" state to disable auto-comeback loop
        navigate("/server-error", {
          state: { reason: "server_error" },
          replace: true,
        });
      }
    };

    window.addEventListener("api-error-500", handle500Error);
    return () => {
      window.removeEventListener("api-error-500", handle500Error);
    };
  }, [navigate, location]);

  return children;
};

export default NetworkGuard;
